import {
  TRANSLOCO_LOADER, TranslocoModule,
  provideTransloco
} from '@jsverse/transloco';
import { NgModule } from '@angular/core';
import { environment } from '../../environments/environment';
import { SgWebHttpClient } from '@ds/ng-wt-helpers/http';
import { CompositeTranslateLoader } from './composite-translation.loader';

export function TranslationLoaderFactory(http: SgWebHttpClient) {
  return new CompositeTranslateLoader(http, [
    { path: './resources/i18n/app/', extn: '.json' },
    { path: './resources/i18n/errors/', extn: '.json' },
    //{ path:'api/translateLangs?lang='}, // server-side
    { path: './resources/i18n/messages/', extn: '.json' },
  ]);
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_LOADER,
      useFactory: TranslationLoaderFactory,
      deps: [SgWebHttpClient],
    },
    provideTransloco({
      config: {
        availableLangs: ['en', 'es'],
        defaultLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
    }),
  ],
})
export class TranslocoRootModule { }
